export default __webpack_public_path__ + "static/media/france.b7be9356.svg";